import { render, staticRenderFns } from "./dialog_share_direct.vue?vue&type=template&id=5a24eafa&scoped=true&"
import script from "./dialog_share_direct.vue?vue&type=script&lang=js&"
export * from "./dialog_share_direct.vue?vue&type=script&lang=js&"
import style0 from "./dialog_share_direct.vue?vue&type=style&index=0&id=5a24eafa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a24eafa",
  null
  
)

export default component.exports